import { render } from "./article-list.vue?vue&type=template&id=872db170&scoped=true"
import script from "./article-list.vue?vue&type=script&lang=js"
export * from "./article-list.vue?vue&type=script&lang=js"

import "./article-list.vue?vue&type=style&index=0&id=872db170&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872db170"]])

export default __exports__